import React from "react";
import { useState, useEffect } from "react";
import ShowerOutlinedIcon from '@mui/icons-material/ShowerOutlined';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import { Link } from 'react-router-dom';
import { collection, getDocs, onSnapshot } from 'firebase/firestore';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import { db } from '../firebase';
import notFound from './not-found.jpg'
import { motion } from "framer-motion"

import "./welcome.css";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Slider,
  Button,
} from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';


function valuetext(value) {
  return `KES ${value}`;
}
 const HOUSES_PER_PAGE = 12;

export default function Welcome() {


  const [type, setType] = useState("");
const [category, setCategory] = useState("");
const [city, setCity] = useState("");
const [area, setArea] = React.useState("");


const rentalCategories = [
  { value: "Bedsitter", label: "Bedsitter" },
  { value: "One bedroom units", label: "One bedroom units" },
  { value: "Two bedroom units", label: "Two bedroom units" },
  { value: "Three bedroom units", label: "Three bedroom units" },
  { value: "Four bedroom units and above", label: "Four bedroom units and above" },
  { value: "Singles", label: "Singles" },
];

const otherCategories = [
  { value: 70, label: "" },
];


const airbnbCategories = [
  { value: "Bedsitter", label: "Bedsitter" },
  { value: "One bedroom" , label: "One bedroom" },
  { value: "Two bedroom", label: "Two bedroom" },
  { value: "Three bedroom", label: "Three bedroom" },
  { value: "Four bedroom", label: "Four bedroom" },
];


const hotelCategories = [
  { value: "Single room", label: "Single room" },
  { value: "Twin room", label: "Twin room" },
  { value: "Double room", label: "Double room" },
  { value: "Triple room", label: "Triple room" },
  { value: "Quad room", label: "Quad room" },
  { value: "Hollywood twin room", label: "Hollywood twin room" },
  { value: "Double-double room", label: "Double-double room" },
  { value: "King room", label: "King room" },
  { value: "Queen room", label: "Queen room" },
  { value: "Interconnecting room", label: "Interconnecting room" },
  { value: "Adjoining room", label: "Adjoining room" },
  { value: "Adjacent room", label: "Adjacent room" },
  { value: "Parlour room", label: "Parlour room" },
  { value: "Studio room", label: "Studio room" },
  { value: "Cabana room", label: "Cabana room" },
  { value: "Suite room", label: "Suite room" },
  { value: "Duplex room", label: "Duplex room" },
  { value: "Efficiency room", label: "Efficiency room" },
  { value: "Hospitality room", label: "Hospitality room" },
  { value: "Penthouse room", label: "Penthouse room" },
  { value: "Lanai room", label: "Lanai room" },
];

const apartmentCategories = [
  { value: "Studio Apartment", label: "Studio Apartment" },
  { value: "2, 3, 4 bhk Apartment", label: "2, 3, 4 bhk Apartment" },
  { value: "Duplex Apartments", label: "Duplex Apartments" },
  { value: "Penthouse Apartments", label: "Penthouse Apartments" },
  { value: "Row Houses", label: "Row Houses" },
  { value: "Villa Apartments", label: "Villa Apartments" },
  { value: "Gated Communities", label: "Gated Communities" },
  { value: "Integrated Township", label: "Integrated Township" },
];

const nairobiLocations = [
  { value: "Kahawa Sukari", label: "Kahawa Sukari" },
  { value: "Wendani", label: "Wendani" },
  { value: "Pangani", label: "Pangani" },
  { value: "Ngara", label: "Ngara" },
  { value: "Parklands", label: "Parklands" },
  { value: "Westlands", label: "Westlands" },
  { value: "Ruiru", label: "Ruiru" },
  { value: "Kihunguro", label: "Kihunguro" },
];

const KisiiLocations = [
  { value: "Nyanchwa", label: "Nyanchwa" },
  { value: "Kisumu Ndogo", label: "Kisumu Ndogo" },
  { value: "Canan area", label: "Canan area" },
  { value: "Saveways", label: "Saveways" },
  { value: "Milimani", label: "Milimani" },
  { value: "Cathedral area", label: "Cathedral area" },
  { value: "Daraja Mbili", label: "Daraja Mbili" },
  { value: "Galilaya", label: "Galilaya" },
  { value: "Mwembe Junction", label: "Mwembe Junction" },
  { value: "Along Mwembe Road to Kamel Park", label: "Along Mwembe Road to Kamel Park" },
  // add Ufanisi, Roma and Minyinkwa areas
  { value: "Ufanisi", label: "Ufanisi" },
  { value: "Roma", label: "Roma" },
  { value: "Minyinkwa", label: "Minyinkwa" },
  
];
const MeruLocations = [
  { value: "Ntharene", label: "Ntharene" },
  { value: "Kanyakine", label: "Kanyakine" },
  { value: "Mwichiune", label: "Mwichiune" },
  { value: "Nkubu", label: "Nkubu" },
  { value: "Kariene", label: "Kariene" },
  { value: "Mitunguu Town", label: "Mitunguu Town" },
  { value: "Meru Town Central", label: "Meru Town Central" },
  { value: "Makutano", label: "Makutano" },
  { value: "Mount Kenya University", label: "Mount Kenya University" },
  { value: "Meru", label: "Meru" },
];

const getLocations = () => {
  if (city === 'Nairobi') {
    return nairobiLocations;
  } else if (city === 'Kisii') {
    return KisiiLocations;
  } else if (city === 'Meru') {
    return MeruLocations;
  } else {
    return otherCategories;
  }
};

const getCategories = () => {
  if (type === 'Rentals') {
    return rentalCategories;
  } else if (type === 'Apartments') {
    return apartmentCategories;
  } else if (type === 'Airbnbs') {
    return airbnbCategories;
  } else if (type === 'Hotels') {
    return hotelCategories;
  } else {
    return otherCategories;
  }
};

const handleTypeChange = (event) => {
  setType(event.target.value);
};

const handleCategoryChange = (event) => {
  setCategory(event.target.value);
};

const handleCityChange = (event) => {
  setCity(event.target.value);
};

const handleAreaChange = (event) => {
  setArea(event.target.value);
};


  const [value, setValue] = React.useState([0, 100000000]);

  const [houses, setHouses] = useState([]);


  const [max, setMax] = useState(100000000);

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  if(1 === 2){
    console.log(data)
    console.log(filteredData)
    setValue([0, 1500000])
  }

  useEffect(() => {
    const collectionRef = collection(db, 'houses');
    const storage = getStorage();

    getDocs(collectionRef)
      .then((querySnapshot) => {
        const newData = [];

        querySnapshot.forEach((doc) => {
          const docRefid = doc.id;
          const { name, imageUrl, address, bedrooms, bathrooms, description, price } = doc.data();
          const imageRef = ref(storage, imageUrl);

          getDownloadURL(imageRef).then((url) => {
            newData.push({ name, imageUrl: url, address, bedrooms, bathrooms, description, price, id: docRefid });
            if (newData.length === querySnapshot.size) {
              setData(newData);
              setFilteredData(newData);
            }
          });
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

    useEffect(() => {
      const unsubscribe = onSnapshot(collection(db, "houses"), (snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setHouses(data);
      });
      return unsubscribe;
    }, []);



    
    const filteredHouses = houses.filter((house) =>
        (type === "" || house.type === type) && (city === "" || house.city === city) && (area === "" || house.area === area) && 
        // house.category is an array with 2 values, use all of them
        (category === "" || (Array.isArray(house.category) && house.category.some(cat => category.includes(cat)))
        || (typeof house.category === 'string' && category.includes(house.category))
        )
        // that only used the first value, use all the values
        // (category === "" || house.category
        //  === category)
        && (
         ( max || value) === 100000000 || parseInt(house.price) <= (max || value)
        )
    );


    const slideShowImages = [
      require("../../assets/background.jpeg"),
      require("./back16.jpg"),
      require("./back12.jpg"),
      require("../Home/backnew13.jpg"),
      require("./back14.jpeg"),
      require("./back15.jpeg"),
    ];

    const [index, setIndex] = useState(0);

    useEffect(() => {
      const interval = setInterval(() => {
        setIndex(prevIndex => (prevIndex + 1) % slideShowImages.length);
      }, 10000);
      return () => clearInterval(interval);
    }, [slideShowImages.length]);
      
    const handleFormClear = () => {
      setType("");
      setCategory("");
      setCity("");
      setArea("");
      setValue([0, 100000000]);
      setMax(100000000);
    };


 

  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredHouses.length / HOUSES_PER_PAGE);

  const startIndex = (currentPage - 1) * HOUSES_PER_PAGE;
  const endIndex = startIndex + HOUSES_PER_PAGE;

  const displayedHouses = filteredHouses
    .filter((house) => !house.full || house.full)
    .slice(startIndex, endIndex);


    const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };




  return (
    <div className="welcomepage">
       <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 1 }}
    >
       <div className="slideshow-container">
      {slideShowImages.map((image, i) => (
        <div
          key={image}
          className={`slideshow-image ${i === index ? 'active' : ''}`}
          style={{ backgroundImage: `url(${image})` }}
          onClick={handleFormClear}
        >
        </div>
      ))}
    
      <div className="welcome">
      <div className="slideshow-text">
            <div className="welcomemessage">

          <h1>Find your dream home</h1>

          <p>
            House hunting service is one of the main services we offer apart
            from property management
            <br /> and land brokerage corporate bodies or individuals.{" "}
          </p>
        </div>



          </div>
        <div className="card1" style={{ background: "white", opacity: "0.9" }}>
          <div className="selections">
            
          <FormControl
  required
  sx={{ m: 1, minWidth: 120 }}
  className="slider"
>
  <InputLabel id="demo-simple-select-required-label">
    Type
  </InputLabel>
  <Select
    labelId="demo-simple-select-required-label"
    id="demo-simple-select-required"
    value={type}
    label="Type *"
    onChange={handleTypeChange}
  >
    <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="Rentals">Rentals</MenuItem>
                <MenuItem value="Apartments">Apartments</MenuItem>
                <MenuItem value="Airbnbs">Airbnbs</MenuItem>
                <MenuItem value="Hotels">Hotels</MenuItem>
  </Select>

</FormControl>
<FormControl
  required
  sx={{ m: 1, minWidth: 120 }}
  className="slider"
>
  <InputLabel id="demo-simple-select-required-label">
    Categories
  </InputLabel>
  <Select
    labelId="demo-simple-select-required-label"
    id="demo-simple-select-required"
    value={category}
    label="Categories *"
    onChange={handleCategoryChange}
  >
    <MenuItem value="">
                  <em>None</em>
                </MenuItem>
    {
      getCategories().map((item) => (
        <MenuItem value={item.value}>{item.label}</MenuItem>
      ))

    }
    
  </Select>
  
</FormControl>
<FormControl
  required
  sx={{ m: 1, minWidth: 120 }}
  className="slider"
>
  <InputLabel id="demo-simple-select-required-label">
    Location
  </InputLabel>
  <Select
    labelId="demo-simple-select-required-label"
    id="demo-simple-select-required"
    value={city}
    label="Location *"
    onChange={handleCityChange}
  >
  <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="Nairobi">Nairobi</MenuItem>
                <MenuItem value="Kisii">Kisii</MenuItem>
                <MenuItem value="Meru">Meru</MenuItem>
                
  </Select>
</FormControl>
<FormControl
  required
  sx={{ m: 1, minWidth: 120 }}
  className="slider"
>
  <InputLabel id="demo-simple-select-required-label">
    Areas
  </InputLabel>
  <Select
    labelId="demo-simple-select-required-label"
    id="demo-simple-select-required"
    value={area}
    label="Areas *"
    onChange={handleAreaChange}
  >
 <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {
                  getLocations().map((item) => (
                    <MenuItem value={item.value}>{item.label}</MenuItem>
                  ))

                }
  </Select>
</FormControl>
          </div>
          <div
            className="range"
            style={{ width: "400px", marginLeft: "650px", fontSize: "20px" }}
          >
            Price range:{" "}
            <span style={{ color: "#ec2029" }}>KES 0 to KES 100,000,000</span>{" "}
          </div>
          <div className="sliderbar">
            <Button
              variant="contained"
              style={{
                width: "300px",
                height: "50px",
                backgroundColor: "#ec2029",
                marginLeft: "7px",
              }}
            >
              Search
            </Button>
            <Slider
              className="slider"
              style={{
                width: "590px",
                marginLeft: "350px",
                color: "#ec2029",
                marginTop: "20px",
              }}
              getAriaLabel={() => "Price range"}
              max={100000000}
              min={0}
              value={max}
              onChange={(e) => {
                setMax(e.target.value);
              }}
              valueLabelDisplay="auto"
              getAriaValueText={valuetext}
            />
            <div className="range1">
              max price: <input type="number" value={max || value} onChange={
                (e) => {
                  setMax(e.target.value);
                }
              }/>

              </div>

          </div>
        </div>
      </div>
</div>
      {/* <AnimationOnScroll
  animateIn = "animate__bounceIn"
  animateOnce = {true}
  > */}
  <div className="renting-wrapper">
     <div className='renting'>
      <div className="rent">
      {displayedHouses.length ? (
        displayedHouses.map((house) => (
          <div key={house.name} className="allrent">
            <div className="container1">
              <img
                src={house.imageUrl}
                alt={house.name}
              />
              <div className="overlay"></div>
              <div className="details">
                <p>Renting at KES<b>{house.price}</b> </p>
                {house.type === "Rentals" && (
                <button style={{ backgroundColor: house.full ? "red" : "green" }}>
                  {house.full ? "Occupied" : "Vacant" }
                </button>
                )}
              </div>
            </div>
            <div className="name1">
              <p>{house.name}</p>
            </div>   
            <div className="location">
              <p>{house.address}</p>
            </div>
            <div className="rooms">
              <BedOutlinedIcon className='roomicon' />
              <div className="roomsicontextwrapper"></div>
              <div className="space2"></div>
              <p>{house.bedrooms}</p>
              <div className="space"></div>
              <ShowerOutlinedIcon className='roomicon' />
              <div className="space2"></div>
              <p>{house.bathrooms}</p>
            </div>
            <div className="more">
              <h4>FOR RENT. TOWNHOUSES FOR RENT</h4>
              <Link to={`/houses/${house.id}`}>
                <button variant="contained" className='btn'>Details</button>
              </Link>
            </div>
          </div>
        ))
      ) : (
        <div className="nohouse">
          <img src={notFound} alt="no property found" />
          <h1>No property found</h1>
        </div>
      )}
</div>
      {/* show previous page button if not on the first page */}
      <div className="pagination">
      {currentPage > 1 && (
        <button onClick={handlePrevPage}>
        <ArrowBackIosIcon />
        </button>
      )}

      {/* show next
      page button if not on the last page */}
      {currentPage < totalPages && (
        <button onClick={handleNextPage}>
        <ArrowForwardIosIcon />
        </button>
      )}
      </div>
    </div>
    </div>
    {/* </AnimationOnScroll> */}
    </motion.div>
    </div>
  );
}
